import script from "./VVVUserProfileNew.vue?vue&type=script&setup=true&lang=js"
export * from "./VVVUserProfileNew.vue?vue&type=script&setup=true&lang=js"

import "./VVVUserProfileNew.vue?vue&type=style&index=0&id=fc0b980c&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\CSD.SPA\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc0b980c"]])

export default __exports__